// FOUNDATION
// FEATURE
// PROJECT
require("./project/trigger-rtl");

require("./project/lazy-loading");